"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getErrorMessage = exports.getSpaceURLParams = exports.isURLGatherSpace = exports.gatherSpaceURLRegex = exports.gatherURLRegex = exports.getRandomPointNearPoint = exports.isInteractableTemplate = exports.hasOwnProperty = exports.isTemplateType = exports.vehicleFromVehicleId = exports.itemFromItemString = exports.allSettled = exports.getFormattedHubSpotDate = exports.assertUnreachable = exports.chunkArray = exports.buildPlayerFromPartial = exports.getMoveDirection = exports.isValidSpaceName = exports.containsSpecialCharsExcludingSeparators = exports.delay = exports.hasPermissionToEditUser = exports.hasSpaceRole = exports.isMember = exports.isMemberRole = exports.getCoreRolesFromStringArray = exports.getRoleWithFallbackToGuestRole = exports.isCoreRole = exports.getRoleNames = exports.arrayAverage = exports.roomURLIdToDBId = exports.getLeftDirection = exports.directionFromSpriteDirection = exports.randomizeObjectUrlFromPrefix = exports.intersectsPos = exports.overlapsBox = exports.intersectsBox = exports.parseBoxCoordinates = exports.intersects = exports.buildSpaceId = exports.makeId = exports.VALID_ID_CHARS = exports.checkTimeInFuture = exports.getStartDatePlusFifteenMins = exports.getDistanceFromObjectBoundary = exports.dist = exports.getClosestUnblockedPosition = exports.hasBlock = exports.hasPlayerBlock = exports.getNeighbors = exports.clamp = void 0;
exports.sanitizeFilename = exports.isOrientationType = exports.getRandomIntegerInRange = exports.getRandomNumberInRange = exports.isAnonymous = exports.gatherEventMessageRecipientToPrisma = exports.gatherEventMessageRecipientToLegacy = exports.getNameFromSpace = exports.getUrlFromSpaceId = exports.getSpacePathFromId = exports.isGatherOfficeSpace = exports.parseTextFromHTML = exports.isValidURL = exports.validateSpaceId = exports.getSpaceIdFromPath = exports.getSpaceIdFromURL = exports.getSpaceNameFromURL = exports.errString = exports.buildErrorContext = exports.ErrorContext = exports.isErrorContextAttributes = exports.errMsgOrDefault = exports.guaranteedError = void 0;
const Player_1 = require("@gathertown/gather-game-common/dist/src/public/Player");
const ramda_1 = require("ramda");
const constants_1 = require("./constants");
const users_1 = require("./resources/users");
const client_1 = require("gather-prisma-types/dist/src/public/client");
const ts_utils_1 = require("./ts-utils");
const events_1 = require("./resources/events");
const fpHelpers_1 = require("./public/fpHelpers");
const axios_1 = require("gather-common-including-video/dist/src/public/axios");
const positionUtils_1 = require("@gathertown/gather-game-common/dist/src/public/positionUtils");
const envShared_1 = require("gather-env-config/dist/src/public/envShared");
function clamp(num, min, max) {
    return num <= min ? min : num >= max ? max : num;
}
exports.clamp = clamp;
function getNeighbors(x, y, includeDiagonalNeighbors = false) {
    const result = [
        { x: x - 1, y },
        { x: x + 1, y },
        { x, y: y + 1 },
        { x, y: y - 1 },
    ];
    if (includeDiagonalNeighbors) {
        result.push({ x: x - 1, y: y - 1 }, { x: x - 1, y: y + 1 }, { x: x + 1, y: y + 1 }, { x: x + 1, y: y - 1 });
    }
    return result;
}
exports.getNeighbors = getNeighbors;
function hasPlayerBlock(x, y, map, players) {
    for (const playerId in players) {
        const player = players[playerId];
        if (player.map === map && !player.ghost && player.x === x && player.y === y)
            return playerId;
    }
    return false;
}
exports.hasPlayerBlock = hasPlayerBlock;
function hasBlock(x, y, map, collisions, players, dimensions) {
    if (y < 0 || y >= dimensions[1] || x < 0 || x >= dimensions[0])
        return true;
    const yObj = collisions[y];
    if (yObj?.[x])
        return true;
    return !!hasPlayerBlock(x, y, map, players);
}
exports.hasBlock = hasBlock;
function getClosestUnblockedPosition(source, coords, coordsMapId, collisions, players, dimensions) {
    const firstCoord = coords[0];
    if (!firstCoord)
        return null;
    if (coordsMapId !== source.map)
        return { ...firstCoord, map: coordsMapId };
    let closestPoint = firstCoord;
    for (const { x, y } of coords.slice(1)) {
        const sourceAsPoint = (0, positionUtils_1.dangerouslyCastToPoint)(source);
        if (!hasBlock(x, y, coordsMapId, collisions, players, dimensions) &&
            (!closestPoint ||
                (0, positionUtils_1.manhattanDistance)({ x, y }, sourceAsPoint) < (0, positionUtils_1.manhattanDistance)(closestPoint, sourceAsPoint))) {
            closestPoint = { x, y };
        }
    }
    return { ...closestPoint, map: coordsMapId };
}
exports.getClosestUnblockedPosition = getClosestUnblockedPosition;
function dist(x1, x2, y1, y2) {
    return Math.sqrt((x1 - x2) ** 2 + (y1 - y2) ** 2);
}
exports.dist = dist;
function getDistanceFromObjectBoundary(position, obj) {
    if (!position || !obj)
        return null;
    const playerX = position.x + 0.5;
    const playerY = position.y + 0.5;
    const xDist = Math.max(obj.x - playerX, playerX - obj.x - obj.width);
    const yDist = Math.max(obj.y - playerY, playerY - obj.y - obj.height);
    return Math.max(xDist, yDist) + Math.abs((xDist + yDist) / 100000000000);
}
exports.getDistanceFromObjectBoundary = getDistanceFromObjectBoundary;
const getStartDatePlusFifteenMins = (startDate) => {
    const newStartDate = new Date(Date.now() + 15 * 60000);
    if (startDate < newStartDate) {
        return newStartDate;
    }
    else {
        return startDate;
    }
};
exports.getStartDatePlusFifteenMins = getStartDatePlusFifteenMins;
const checkTimeInFuture = (time) => new Date(Date.now()) < time;
exports.checkTimeInFuture = checkTimeInFuture;
exports.VALID_ID_CHARS = "qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM1234567890";
const makeId = (n) => Array.from(new Array(n).keys())
    .map(() => exports.VALID_ID_CHARS[Math.floor(Math.random() * exports.VALID_ID_CHARS.length)])
    .join("");
exports.makeId = makeId;
const buildSpaceId = (name, slug) => `${slug}\\${name}`;
exports.buildSpaceId = buildSpaceId;
const intersects = (pointerX, pointerY, targetX, targetY, targetWidth = 1, targetHeight = 1) => pointerX < targetX + targetWidth &&
    pointerX >= targetX &&
    pointerY < targetY + targetHeight &&
    pointerY >= targetY;
exports.intersects = intersects;
const parseBoxCoordinates = (_x1, _y1, _x2, _y2) => {
    let x1 = _x1, y1 = _y1, x2 = _x2, y2 = _y2;
    if (_x1 > _x2) {
        x1 = _x2;
        x2 = _x1;
    }
    if (_y1 > _y2) {
        y1 = _y2;
        y2 = _y1;
    }
    return { x1, y1, x2, y2 };
};
exports.parseBoxCoordinates = parseBoxCoordinates;
const intersectsBox = (boxCoordinates, targetX1, targetY1, targetWidth = 1, targetHeight = 1) => {
    const { x1, y1, x2, y2 } = boxCoordinates;
    const targetX2 = targetX1 + targetWidth - 1;
    const targetY2 = targetY1 + targetHeight - 1;
    return x1 <= targetX2 && x2 >= targetX1 && y1 <= targetY2 && y2 >= targetY1;
};
exports.intersectsBox = intersectsBox;
const overlapsBox = (boxCoordinates, targetX1, targetY1, targetWidth = 1, targetHeight = 1) => {
    const { x1, y1, x2, y2 } = boxCoordinates;
    const targetX2 = targetX1 + targetWidth - 1;
    const targetY2 = targetY1 + targetHeight - 1;
    return x1 <= targetX1 && x2 >= targetX2 && y1 <= targetY1 && y2 >= targetY2;
};
exports.overlapsBox = overlapsBox;
const intersectsPos = (pointer, target, targetWidth = 1, targetHeight = 1) => (0, exports.intersects)(pointer.x, pointer.y, target.x, target.y, targetWidth, targetHeight);
exports.intersectsPos = intersectsPos;
const randomizeObjectUrlFromPrefix = (obj) => {
    if (obj.properties?.deterministicUrlPrefix) {
        obj.properties = {
            ...obj.properties,
            url: generateURLFromPrefix(obj.properties.deterministicUrlPrefix),
        };
    }
};
exports.randomizeObjectUrlFromPrefix = randomizeObjectUrlFromPrefix;
const generateURLFromPrefix = (prefix) => prefix + (0, exports.makeId)(16) + "table" + Math.floor(Math.random() * 10);
const directionFromSpriteDirection = (sd) => {
    switch (sd) {
        case Player_1.SpriteDirection.Down:
        case Player_1.SpriteDirection.DownAlt:
            return Player_1.MoveDirection.Down;
        case Player_1.SpriteDirection.Left:
        case Player_1.SpriteDirection.LeftAlt:
            return Player_1.MoveDirection.Left;
        case Player_1.SpriteDirection.Right:
        case Player_1.SpriteDirection.RightAlt:
            return Player_1.MoveDirection.Right;
        case Player_1.SpriteDirection.Up:
        case Player_1.SpriteDirection.UpAlt:
            return Player_1.MoveDirection.Up;
        case Player_1.SpriteDirection.Dance1:
        case Player_1.SpriteDirection.Dance2:
        case Player_1.SpriteDirection.Dance3:
        case Player_1.SpriteDirection.Dance4:
            return Player_1.MoveDirection.Dance;
        default:
            return null;
    }
};
exports.directionFromSpriteDirection = directionFromSpriteDirection;
const getLeftDirection = (md) => {
    switch (md) {
        case Player_1.MoveDirection.Up:
            return Player_1.MoveDirection.Left;
        case Player_1.MoveDirection.Right:
            return Player_1.MoveDirection.Up;
        case Player_1.MoveDirection.Down:
            return Player_1.MoveDirection.Right;
        case Player_1.MoveDirection.Left:
            return Player_1.MoveDirection.Down;
        default:
            return null;
    }
};
exports.getLeftDirection = getLeftDirection;
const roomURLIdToDBId = (roomURLId) => roomURLId.replace("/", "\\");
exports.roomURLIdToDBId = roomURLIdToDBId;
const arrayAverage = (array) => array.length > 0 ? array.reduce((acc, e) => acc + e) / array.length : undefined;
exports.arrayAverage = arrayAverage;
const getRoleNames = (roles) => roles && roles.length > 0 ? roles.join(", ") : "Guest";
exports.getRoleNames = getRoleNames;
function isCoreRole(role) {
    return !(0, fpHelpers_1.isNil)(role) && Object.values(Player_1.CoreRole).some((coreRole) => coreRole === role);
}
exports.isCoreRole = isCoreRole;
function getRoleWithFallbackToGuestRole(role) {
    return isCoreRole(role) ? role : Player_1.CoreRole.Guest;
}
exports.getRoleWithFallbackToGuestRole = getRoleWithFallbackToGuestRole;
function getCoreRolesFromStringArray(roles) {
    const coreRoles = [];
    roles.forEach((role) => isCoreRole(role) && coreRoles.push(role));
    return coreRoles;
}
exports.getCoreRolesFromStringArray = getCoreRolesFromStringArray;
const isMemberRole = (role) => isCoreRole(role) && role !== Player_1.CoreRole.Guest;
exports.isMemberRole = isMemberRole;
const isMember = (user) => (0, exports.isMemberRole)(user?.role);
exports.isMember = isMember;
const hasSpaceRole = (currentSpaceRole, requiredSpaceRoles) => (0, fpHelpers_1.isNotNil)(currentSpaceRole) && requiredSpaceRoles.includes(currentSpaceRole);
exports.hasSpaceRole = hasSpaceRole;
const hasPermissionToEditUser = (requestingUserRole, userToUpdateNewAndRemovedRoles) => {
    if (!(0, exports.isMemberRole)(requestingUserRole))
        return false;
    if (userToUpdateNewAndRemovedRoles.length === 0)
        return true;
    const rolesAllowedToUpdate = users_1.UPDATE_ROLE_PERMISSIONS[requestingUserRole];
    return (0, ramda_1.all)((role) => rolesAllowedToUpdate.includes(role), userToUpdateNewAndRemovedRoles);
};
exports.hasPermissionToEditUser = hasPermissionToEditUser;
async function delay(delayMs) {
    return new Promise((res) => {
        setTimeout(res, delayMs);
    });
}
exports.delay = delay;
const containsSpecialCharsExcludingSeparators = (str) => {
    const regex = new RegExp(/[$&+,:;=?@#%!|'"`~<>.^*(){}[\]\\/]/);
    return regex.test(str);
};
exports.containsSpecialCharsExcludingSeparators = containsSpecialCharsExcludingSeparators;
const isValidSpaceName = (spaceName) => spaceName.match(constants_1.VALID_SPACE_NAME_PATTERN) && spaceName.length <= constants_1.MAX_SPACE_NAME_LENGTH;
exports.isValidSpaceName = isValidSpaceName;
const getMoveDirection = (nextPos, initialPos) => {
    let direction = null;
    if (nextPos.x === initialPos.x) {
        if (nextPos.y < initialPos.y) {
            direction = Player_1.MoveDirection.Up;
        }
        else {
            direction = Player_1.MoveDirection.Down;
        }
    }
    else if (nextPos.y === initialPos.y) {
        if (nextPos.x < initialPos.x) {
            direction = Player_1.MoveDirection.Left;
        }
        else {
            direction = Player_1.MoveDirection.Right;
        }
    }
    else {
    }
    return direction;
};
exports.getMoveDirection = getMoveDirection;
const buildPlayerFromPartial = (playerId, initialInfo = null) => {
    const player = new Player_1.Player(playerId);
    for (const k in initialInfo) {
        if (initialInfo[k] !== undefined) {
            player[k] = initialInfo[k];
        }
    }
    player.name = player.name.substring(0, constants_1.MAX_NAME_LENGTH);
    player.textStatus = player.textStatus.substring(0, constants_1.MAX_MEDIUM_LENGTH);
    return player;
};
exports.buildPlayerFromPartial = buildPlayerFromPartial;
const chunkArray = (fullArray, chunkSize) => {
    if (chunkSize === 0)
        return [fullArray];
    return fullArray.reduce((chunkedArray, value, arrIndex) => {
        const chunkIndex = Math.floor(arrIndex / chunkSize);
        if (!chunkedArray[chunkIndex]) {
            chunkedArray[chunkIndex] = [];
        }
        chunkedArray[chunkIndex].push(value);
        return chunkedArray;
    }, []);
};
exports.chunkArray = chunkArray;
function assertUnreachable(x) {
    throw new Error(`assertUnreachable was reachable. received: ${x}`);
}
exports.assertUnreachable = assertUnreachable;
const getFormattedHubSpotDate = (date) => {
    if (!date) {
        date = new Date(Date.now());
    }
    return date.toISOString().substring(0, 10);
};
exports.getFormattedHubSpotDate = getFormattedHubSpotDate;
const allSettled = (promises) => {
    const mappedPromises = promises.map((p) => p
        .then((value) => ({
        status: "fulfilled",
        value,
    }))
        .catch((reason) => ({
        status: "rejected",
        reason,
    })));
    return Promise.all(mappedPromises);
};
exports.allSettled = allSettled;
const itemFromItemString = (itemString) => {
    try {
        return JSON.parse(itemString);
    }
    catch {
        return undefined;
    }
};
exports.itemFromItemString = itemFromItemString;
const vehicleFromVehicleId = (vehicleId) => {
    try {
        return JSON.parse(vehicleId);
    }
    catch {
        return undefined;
    }
};
exports.vehicleFromVehicleId = vehicleFromVehicleId;
function isTemplateType(obj, type) {
    return obj.type === type;
}
exports.isTemplateType = isTemplateType;
function hasOwnProperty(obj, prop) {
    return obj.hasOwnProperty(prop);
}
exports.hasOwnProperty = hasOwnProperty;
function isInteractableTemplate(obj) {
    return (obj !== null &&
        typeof obj === "object" &&
        hasOwnProperty(obj, "distThreshold") &&
        typeof obj.distThreshold === "number");
}
exports.isInteractableTemplate = isInteractableTemplate;
const getRandomPointNearPoint = (x, y, offset = 5) => {
    const offsetX = Math.floor(Math.random() * offset);
    const offsetY = Math.floor(Math.random() * offset);
    return {
        x: Math.random() > 0.5 ? x + offsetX : x - offsetX,
        y: Math.random() > 0.5 ? y + offsetY : y - offsetY,
    };
};
exports.getRandomPointNearPoint = getRandomPointNearPoint;
exports.gatherURLRegex = /^https?:\/\/(?:((?:(\w|\d|-|\.)*\.)?gather\.town)|(?:localhost:8080))/;
exports.gatherSpaceURLRegex = /^https?:\/\/(?:((?:(\w|\d|-|\.)*\.)?gather\.town)|(?:localhost:8080))\/app/;
const gatherLocalSpaceURLRegex = /^https?:\/\/((?:localhost:(?:3000|8080))|(?:.*ngrok(?:-free)?.app))\/app/;
const isURLGatherSpace = (urlToCheck) => urlToCheck.match(exports.gatherSpaceURLRegex) ||
    (envShared_1.isLocalOrTest && urlToCheck.match(gatherLocalSpaceURLRegex));
exports.isURLGatherSpace = isURLGatherSpace;
const getSpaceURLParams = (urlToParse) => {
    if (!(0, exports.isURLGatherSpace)(urlToParse))
        return null;
    try {
        const parsedUrl = new URL(urlToParse);
        return parsedUrl.searchParams;
    }
    catch {
        return null;
    }
};
exports.getSpaceURLParams = getSpaceURLParams;
const getErrorMessage = (error, fallbackMessage = "Unknown Error") => {
    if (axios_1.axios.isAxiosError(error)) {
        return (error.response?.data.message ?? error.response?.data.errors?.[0]?.message ?? fallbackMessage);
    }
    else {
        return (0, exports.errMsgOrDefault)(error);
    }
};
exports.getErrorMessage = getErrorMessage;
const guaranteedError = (error) => {
    if (error instanceof Error)
        return error;
    try {
        throw new Error("Thrown error was not an instance of Error");
    }
    catch (e) {
        if (!(e instanceof Error))
            return Error("this will never happen");
        console.error(`Caught error not instanceof Error.

  Original error: ${error}

  Stacktrace:\n\n${e.stack}`);
        return e;
    }
};
exports.guaranteedError = guaranteedError;
const errMsgOrDefault = (e) => (0, exports.guaranteedError)(e).message;
exports.errMsgOrDefault = errMsgOrDefault;
const isErrorContextAttributes = (attributes) => (0, ts_utils_1.isObject)(attributes) &&
    Object.values(attributes).every((value) => typeof value === "string" || typeof value === "number");
exports.isErrorContextAttributes = isErrorContextAttributes;
class ErrorContext {
    attributes;
    originalError;
    constructor(attributes, originalError) {
        this.attributes = attributes;
        this.originalError = originalError;
    }
}
exports.ErrorContext = ErrorContext;
const buildErrorContext = (error) => error ? new ErrorContext({}, error) : undefined;
exports.buildErrorContext = buildErrorContext;
const errString = (err) => {
    let propertyNames = Object.getOwnPropertyNames(err);
    if (propertyNames.includes("message")) {
        propertyNames = ["message"].concat(propertyNames.filter((n) => n !== "message"));
    }
    if (propertyNames.includes("stack")) {
        propertyNames = propertyNames.filter((n) => n !== "stack").concat(["stack"]);
    }
    return JSON.stringify(err, propertyNames);
};
exports.errString = errString;
const parseGatherPath = (url) => url.match(/^\/(?:app|dashboard|mapmaker)\/(\w*)\/([^/?]*)/);
const parseGatherURL = (url) => url.match(/^https?:\/\/(?:(?:(?:\w|\d|-|\.)*\.)?gather\.town|(?:localhost:8080)|(?:.*ngrok(?:-free)?\.app))\/(?:app|dashboard|mapmaker)\/(\w*)\/([^/?]*)/);
const getSpaceNameFromURL = (url) => {
    const match = parseGatherURL(decodeURIComponent(url));
    return match?.[2] || "";
};
exports.getSpaceNameFromURL = getSpaceNameFromURL;
const getSpaceIdFromURL = (url) => {
    const match = parseGatherURL(decodeURIComponent(url));
    return match ? `${match[1]}\\${match[2]}` : "";
};
exports.getSpaceIdFromURL = getSpaceIdFromURL;
const getSpaceIdFromPath = (path) => {
    const match = parseGatherPath(decodeURIComponent(path));
    return match ? `${match[1]}\\${match[2]}` : "";
};
exports.getSpaceIdFromPath = getSpaceIdFromPath;
const validateSpaceId = (spaceId) => /^[a-zA-Z\d]+[/\\][a-zA-Z\d_-\s]+$/.test(spaceId);
exports.validateSpaceId = validateSpaceId;
const isValidURL = (str) => {
    try {
        new URL(str);
        return true;
    }
    catch (_) {
        return false;
    }
};
exports.isValidURL = isValidURL;
const parseTextFromHTML = (html, options = { markdownLinks: true }) => {
    html = html.replace(/<br>/g, "\n");
    html = html.replace(/<li>(.*?)<\/li>/g, (_, p1) => `\n• ${p1}`);
    html = html.replace(/<\/?ul>/g, "\n");
    if (options.markdownLinks) {
        const anchorMatches = html.matchAll(/<a.*?href="(.*?)".*?>.+<\/a>/g);
        Array(...anchorMatches).forEach((match) => {
            const matchedTag = match[0] || "";
            const matchedURL = match[1] || "";
            const matchedInnerText = new DOMParser().parseFromString(matchedTag, "text/html").body
                .textContent;
            if (matchedTag && matchedURL && matchedInnerText) {
                html = html.replace(matchedTag, `[${matchedInnerText}](${matchedURL})`);
            }
        });
    }
    return new DOMParser().parseFromString(html, "text/html").documentElement.textContent;
};
exports.parseTextFromHTML = parseTextFromHTML;
const isGatherOfficeSpace = (spaceId) => spaceId === constants_1.GATHER_OFFICE_ID;
exports.isGatherOfficeSpace = isGatherOfficeSpace;
function getSpacePathFromId(spaceId) {
    const parts = spaceId.split("\\");
    const length = parts.length;
    if (length >= 2)
        return `/app/${parts[length - 2]}/${encodeURIComponent(parts[length - 1] ?? "")}`;
    return null;
}
exports.getSpacePathFromId = getSpacePathFromId;
const getUrlFromSpaceId = (spaceId, baseUrl = "https://gather.town") => {
    const path = getSpacePathFromId(spaceId);
    if (!path)
        return "";
    return `${baseUrl}${path}`;
};
exports.getUrlFromSpaceId = getUrlFromSpaceId;
function getNameFromSpace(spaceId) {
    const temp = spaceId.split("\\");
    if (temp.length >= 2) {
        return (0, fpHelpers_1.just)(temp[temp.length - 1]);
    }
    else {
        return spaceId;
    }
}
exports.getNameFromSpace = getNameFromSpace;
const gatherEventMessageRecipientToLegacy = (recipient) => (0, ts_utils_1.migrateEnum)(recipient, events_1.GatherEventMessageRecipientBackwardsMigration, events_1.GatherEventMessageRecipientLegacy);
exports.gatherEventMessageRecipientToLegacy = gatherEventMessageRecipientToLegacy;
const gatherEventMessageRecipientToPrisma = (recipient) => (0, ts_utils_1.migrateEnum)(recipient, events_1.GatherEventMessageRecipientMigration, client_1.GatherEventMessageRecipient);
exports.gatherEventMessageRecipientToPrisma = gatherEventMessageRecipientToPrisma;
const isAnonymous = (user) => (0, fpHelpers_1.isNilOrEmpty)(user?.email);
exports.isAnonymous = isAnonymous;
const getRandomNumberInRange = (min, max) => min + Math.random() * (max - min);
exports.getRandomNumberInRange = getRandomNumberInRange;
exports.getRandomIntegerInRange = (0, ramda_1.pipe)(exports.getRandomNumberInRange, Math.floor);
const isOrientationType = (input) => input in constants_1.Orientation;
exports.isOrientationType = isOrientationType;
function sanitizeFilename(inputString) {
    return inputString.replace(/[^.A-Za-z0-9_-]+/g, "-");
}
exports.sanitizeFilename = sanitizeFilename;
//# sourceMappingURL=utils.js.map